import { Store } from "@/zustand/store";
import { StateCreator } from "zustand";

export type SelectedItemsSlice = {
  userId: number | undefined;
  changeUser: (userId: number | undefined) => void;
};

const initialData = {
  userId: undefined,
};

export const createSelectedItemsSlice: StateCreator<
  Store,
  [],
  [],
  SelectedItemsSlice
> = (set) => ({
  ...initialData,
  changeUser: (userId) => set({ userId }),
});
